"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffPrintQrModel = instanceOfLiffPrintQrModel;
exports.LiffPrintQrModelFromJSON = LiffPrintQrModelFromJSON;
exports.LiffPrintQrModelFromJSONTyped = LiffPrintQrModelFromJSONTyped;
exports.LiffPrintQrModelToJSON = LiffPrintQrModelToJSON;
exports.LiffPrintQrModelToJSONTyped = LiffPrintQrModelToJSONTyped;
/**
 * Check if a given object implements the LiffPrintQrModel interface.
 */
function instanceOfLiffPrintQrModel(value) {
    if (!('lineId' in value) || value['lineId'] === undefined)
        return false;
    return true;
}
function LiffPrintQrModelFromJSON(json) {
    return LiffPrintQrModelFromJSONTyped(json, false);
}
function LiffPrintQrModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'lineId': json['lineId'],
        'lineUserName': json['lineUserName'] == null ? undefined : json['lineUserName'],
        'memberName': json['memberName'] == null ? undefined : json['memberName'],
        'frameNo': json['frameNo'] == null ? undefined : json['frameNo'],
        'frameNos': json['frameNos'] == null ? undefined : json['frameNos'],
        'imageJson': json['imageJson'] == null ? undefined : json['imageJson'],
    };
}
function LiffPrintQrModelToJSON(json) {
    return LiffPrintQrModelToJSONTyped(json, false);
}
function LiffPrintQrModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'lineId': value['lineId'],
        'lineUserName': value['lineUserName'],
        'memberName': value['memberName'],
        'frameNo': value['frameNo'],
        'frameNos': value['frameNos'],
        'imageJson': value['imageJson'],
    };
}
